/**
 * Feature 103 (The Key pilot) — defensive `tk-resize` postMessage guard.
 *
 * Ticket 06: origin + shape validation + 200–2000px clamp. IntakeFormModal
 * applies the returned height so the iframe (scrolling="no") can grow and
 * the modal wrapper can scroll.
 */

export const TK_RESIZE_ORIGIN = 'https://thekey.com';
const MIN_HEIGHT = 200;
const MAX_HEIGHT = 2000;

type TkResizeMessageEvent = Pick<MessageEvent, 'origin' | 'data'>;

/**
 * Returns the clamped height (200-2000) for a valid `tk-resize` message from
 * the expected origin while the modal is open, or `null` for anything else
 * (wrong origin, wrong shape, or modal closed).
 */
export function computeClampedTkResizeHeight(
  event: TkResizeMessageEvent,
  isModalOpen: boolean,
): number | null {
  if (!isModalOpen) return null;
  if (event.origin !== TK_RESIZE_ORIGIN) return null;

  const data = event.data as { type?: unknown; height?: unknown } | null | undefined;
  if (!data || typeof data !== 'object') return null;
  if (data.type !== 'tk-resize') return null;
  if (typeof data.height !== 'number' || !Number.isFinite(data.height)) return null;

  return Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, data.height));
}
